import * as React from 'react';
import { useTranslate } from '@tolgee/react';

import { useAbility } from '~/core/contexts/AbilityContext';
import { Icon } from '~/shared/components';

type ModuleItem = {
  label: string;
  subtitle: string;
  icon: React.ReactNode;
  url?: string;
};

const style = {
  color: '#191F2E',
  size: 16
};

export function useModuleItems() {
  const { t } = useTranslate('web-app');
  const ability = useAbility();

  const items: ModuleItem[] = [
    {
      label: t('modules.my_compensation'),
      subtitle: t('menu.rewards'),
      icon: <Icon.MoneyBag color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_COMPENSATION_URL
    },
    {
      label: t('modules.my_talent_card'),
      subtitle: t('menu.opr'),
      icon: <Icon.Badge color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_TALENT_CARD_URL
    },
    {
      label: t('modules.my_targets'),
      subtitle: t('menu.northstar'),
      icon: <Icon.Target color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_TARGETS_URL
    }
  ];

  if (ability.can('view', 'Cheershub')) {
    items.unshift({
      label: t('modules.cheershub'),
      subtitle: t('modules.cheershub'),
      icon: <Icon.Cheershub color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_CHEERSHUB_URL
    });
  }

  return { items };
}
